import React from "react";
// import { PhonePe, Billdesk, PgSelectedTick } from "./icons/svg";
import { renderImg } from "./icons/img";
const PgBlock = (props) => {
    return (
        <div onClick={props.onClick} className={`pgblock--wrapper ${props.selected ? 'selected' : ''}`}>
            {
                props.value === 'phonepe' &&
                <div className="pg--content">
                    {props.selected && <div className="selTick">{renderImg('PgSelectedTick')}</div>}
                    <div>{renderImg('Phonepe')}</div>
                    <div className="pg--text">UPI based App to provide a cashless and a seamless payment experiance</div>
                </div>
            }
            {
                props.value === 'billdesk' &&
                <div className="pg--content">
                    {props.selected && <div className="selTick">{renderImg('PgSelectedTick')}</div>}
                    <div>{renderImg('Billdesk')}</div>
                    <div className="pg--text">All Major Net Banking, Credit / Debit card /
                        e-Wallet SBI, HDFC, ICICI, AXIS, RuPay..
                    </div>
                </div>
            }
            {
                props.value === 'razorpay' &&
                <div className="pg--content">
                    {props.selected && <div className="selTick">{renderImg('PgSelectedTick')}</div>}
                    <div>{renderImg('razorpay')}</div>
                    <div className="pg--text">ಎಲ್ಲಾ ಪ್ರಮುಖ ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್, ಕ್ರೆಡಿಟ್ / ಡೆಬಿಟ್ ಕಾರ್ಡ್ / ಇ-ವಾಲೆಟ್ ಎಸ್ಬಿಐ, ಎಚ್ಡಿಎಫ್ಸಿ, ಐಸಿಐಸಿಐ, ಎಕ್ಸಿಸ್, ರುಪೇ ... / All Major Net Banking, Credit / Debit card /
                        e-Wallet SBI, HDFC, ICICI, AXIS, RuPay ...
                    </div>
                </div>
            }
        </div>
    );
};

export default PgBlock;